import { format } from "date-fns";
import api from "../services/api";

interface INotReturnedResponse {
    codeResult: string;
    data: any[];
}

export interface INotReturnedParams {
    year: string;
    month: string;

}
export interface INotReturned {
    data: string;
    gerente: string;
    representante: string;
    revendedor: string;
    devedor: number;
    revCrm: string;
    kit: number;
    kitId: string;
    ficha: boolean;
    protestado: boolean;
    valorDebito: number;
}


class NotReturnedRepository {
    public async NotReturned({ year, month }: INotReturnedParams): Promise<INotReturned[]> {
        const initialDate = format(new Date(parseInt(year), parseInt(month) - 1, 14, 0, 0, 0), "yyyy-MM-dd HH:mm:ss");
        const endDate = format(new Date(parseInt(year), parseInt(month) - 1, 16, 0, 0, 0), "yyyy-MM-dd HH:mm:ss");

        const body = {
            "tables": ["Pedido", "Kit", "Revendedor", "Representante", "GerenteSetor"],
            "sql": [
                {
                    "coderesult": "NaoRetornou",
                    "query": `SELECT GerenteSetor.nome as Gs,
                    Representante.nome as Rp,
                    Revendedor.nome as Rv, 
                    Revendedor.crm as Crm, 
                    Revendedor.devedor as Devedor, 
                    Kit.numero as Numero,
                    Kit.valor as Valor, 
                    Kit.id as Id, 
                    Kit.ficha as Ficha, 
                    Pedido.acerto as Acerto, 
                    Revendedor.protestado as Protestado 
                    FROM Kit 
                    INNER JOIN Pedido 
                    ON Pedido.id = Kit.pedidoId 
                    INNER JOIN GerenteSetor 
                    ON GerenteSetor.id = Pedido.gerenteSetorId 
                    INNER JOIN Representante 
                    ON Representante.id = Pedido.representanteId 
                    LEFT JOIN Revendedor
                    ON Revendedor.id = Kit.revendedorId 
                    WHERE Kit.estado = 2 
                    AND Pedido.acerto > '${initialDate}' 
                    AND Pedido.acerto < '${endDate}'
                    ORDER BY GerenteSetor.nome, Representante.nome, Revendedor.nome`
                }
            ]
        };

        const response = await api.post<INotReturnedResponse[]>("reports", body);
        console.log(response);
        return this.GetFromCodeResult(response.data, "NaoRetornou").map(result => {
            return {
                data: result.Acerto,
                gerente: result.Gs,
                representante: result.Rp,
                revendedor: result.Rv,
                devedor: result.Devedor,                
                revCrm: result.Crm,
                kit: result.Numero,
                kitId: result.Id,
                ficha: result.Ficha,
                protestado: result.Protestado,
                valorDebito: result.Valor
            }
        });
    }

    GetFromCodeResult(data: INotReturnedResponse[], codeResult: string) {

        return data.find(result => result.codeResult === codeResult)?.data || [];
    }
}

const notReturnedRepository = new NotReturnedRepository();
export default notReturnedRepository;